import "./src/styles/global.css"
// Tambahkan script embedding Cal.com
import React from "react";
export const onRenderBody = ({ setHeadComponents }) => {
  setHeadComponents([
    <script
      key="cal-script"
      dangerouslySetInnerHTML={{
        __html: `(function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { cal.q = cal.q || []; if (arguments.length === 1 && arguments[0] === 'init') return; p(this, arguments); }; if (!d.getElementById('cal-script-bundle')) { let h = d.getElementsByTagName('head')[0]; let j = d.createElement('script'); j.id = 'cal-script-bundle'; j.type = 'text/javascript'; j.async = true; j.src = 'https://app.cal.com/embed/embed.js'; h.appendChild(j); } })(window, 0, 'cal'); Cal("init", "username-anda");`,
      }}
    />,
  ]);
};